'use client';
import React, { useState, useRef, useEffect, useCallback } from 'react';
import { createClient } from '@/lib/supabase/client';

// ─── CONSTANTS ───────────────────────────────────────────────────────────────
const PHONE = '833-846-2316';
const PHONE_DIAL = '+18338462316';
const US_STATES = ['AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA', 'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM', 'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WV', 'WI', 'WY'];

// ─── ICONS ───────────────────────────────────────────────────────────────────
const IcoCheck = () =>
<svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
    <polyline points="20 6 9 17 4 12" />
  </svg>;

const IcoPhone = () =>
<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .18h3a2 2 0 012 1.72c.13 1 .36 1.97.7 2.9a2 2 0 01-.45 2.11L6.09 8.09a16 16 0 006.29 6.29l1.18-1.18a2 2 0 012.11-.45c.93.35 1.9.58 2.9.7A2 2 0 0122 15.4z" />
  </svg>;

const IcoArrow = () =>
<svg width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>;

const IcoAward = () =>
<svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <circle cx="12" cy="8" r="6" />
    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11" />
  </svg>;

const IcoUsers = () =>
<svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" />
  </svg>;

const IcoStar = () =>
<svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>;

const IcoDollar = () =>
<svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <line x1="12" y1="1" x2="12" y2="23" />
    <path d="M17 5H9.5a3.5 3.5 0 100 7h5a3.5 3.5 0 110 7H6" />
  </svg>;

const IcoHeart = () =>
<svg width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" />
  </svg>;

const IcoSuccess = () =>
<svg width="56" height="56" fill="none" stroke="#00C49A" strokeWidth="1.5" viewBox="0 0 24 24">
    <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>;


// ─── STYLES ──────────────────────────────────────────────────────────────────
const css = `
  .nav{position:sticky;top:0;z-index:100;background:rgba(255,255,255,.97);backdrop-filter:blur(14px);border-bottom:1px solid rgba(11,31,58,.09);height:70px;display:flex;align-items:center;padding:0 28px;gap:20px;box-shadow:0 2px 10px rgba(11,31,58,.08);}
  .nav-logo{display:flex;align-items:center;gap:10px;text-decoration:none;flex-shrink:0;cursor:pointer;border:none;background:none;}
  .nav-logo img{width:46px;height:46px;border-radius:50%;object-fit:cover;box-shadow:0 0 0 2px rgba(30,94,191,.18);}
  .nav-logo-text{font-family:'Cormorant Garamond',serif;font-size:17px;font-weight:700;color:#0B1F3A;line-height:1.2;text-align:left;}
  .nav-logo-text small{display:block;font-family:'Nunito Sans',sans-serif;font-size:10px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#1E5EBF;}
  .nav-links{display:flex;align-items:center;gap:2px;margin-left:auto;}
  .nav-links button{padding:7px 13px;border-radius:8px;font-size:13.5px;font-weight:600;color:#0B1F3A;background:none;border:none;cursor:pointer;transition:background .18s,color .18s;white-space:nowrap;font-family:'Nunito Sans',sans-serif;}
  .nav-links button:hover,.nav-links button.active{background:#F7F9FC;color:#1E5EBF;}
  .nav-phone-btn{background:#1E5EBF!important;color:white!important;margin-left:6px;padding:8px 16px!important;border-radius:9px!important;font-weight:700!important;display:inline-flex;align-items:center;gap:6px;text-decoration:none;font-size:13.5px;font-family:'Nunito Sans',sans-serif;}
  .nav-phone-btn:hover{background:#0B1F3A!important;}
  .hamburger{display:none;background:none;border:none;cursor:pointer;margin-left:auto;padding:6px;}
  .mob-menu{display:none;position:fixed;inset:70px 0 0;background:white;z-index:99;flex-direction:column;padding:20px;gap:6px;box-shadow:0 20px 60px rgba(11,31,58,.18);overflow-y:auto;}
  .mob-menu.open{display:flex;}
  .mob-menu button{padding:13px 16px;border-radius:10px;font-size:15px;font-weight:600;color:#0B1F3A;background:none;border:none;cursor:pointer;text-align:left;font-family:'Nunito Sans',sans-serif;}
  .mob-menu button:hover{background:#F7F9FC;}
  .mob-phone{background:#1E5EBF!important;color:white!important;text-align:center!important;margin-top:8px;border-radius:10px!important;}
  .btn{display:inline-flex;align-items:center;gap:8px;padding:14px 28px;border-radius:12px;font-family:'Nunito Sans',sans-serif;font-size:15px;font-weight:700;cursor:pointer;text-decoration:none;transition:transform .2s,box-shadow .2s,background .2s;border:none;}
  .btn-primary{background:#1E5EBF;color:white;box-shadow:0 4px 18px rgba(30,94,191,.35);}
  .btn-primary:hover{background:#0B1F3A;transform:translateY(-2px);}
  .btn-white{background:white;color:#1E5EBF;}
  .btn-white:hover{background:#F7F9FC;transform:translateY(-2px);}
  .btn-outline{background:transparent;color:white;border:2px solid rgba(255,255,255,.6);}
  .btn-outline:hover{border-color:white;background:rgba(255,255,255,.1);}
  .btn-mint{background:#00C49A;color:white;box-shadow:0 4px 18px rgba(0,196,154,.3);}
  .btn-mint:hover{background:#00a882;transform:translateY(-2px);}
  .btn-sm{padding:10px 20px;font-size:14px;}
  .hero{background:linear-gradient(140deg,#0B1F3A 0%,#162d52 55%,#1a4080 100%);min-height:90vh;display:flex;align-items:center;padding:72px 28px 60px;position:relative;overflow:hidden;}
  .hero::before{content:'';position:absolute;inset:0;background:radial-gradient(ellipse 65% 70% at 75% 40%,rgba(74,144,217,.2) 0%,transparent 65%),radial-gradient(ellipse 40% 50% at 5% 90%,rgba(0,196,154,.12) 0%,transparent 60%);pointer-events:none;}
  .hero-inner{max-width:1120px;margin:0 auto;width:100%;display:grid;grid-template-columns:1fr 440px;gap:56px;align-items:center;position:relative;z-index:1;}
  .hero-badge{display:inline-flex;align-items:center;gap:8px;background:rgba(0,196,154,.15);border:1px solid rgba(0,196,154,.3);border-radius:100px;padding:6px 14px;margin-bottom:22px;}
  .hero-badge-dot{width:7px;height:7px;background:#00C49A;border-radius:50%;animation:blink 2s infinite;}
  .hero-badge span{font-size:11px;font-weight:700;color:#00C49A;letter-spacing:.07em;text-transform:uppercase;}
  .hero h1{font-size:clamp(34px,5vw,58px);color:white;margin-bottom:20px;}
  .hero h1 em{font-style:italic;color:#7bb8f0;}
  .hero-sub{font-size:clamp(15px,1.8vw,18px);color:rgba(255,255,255,.75);line-height:1.7;margin-bottom:32px;max-width:480px;}
  .hero-checks{display:flex;flex-wrap:wrap;gap:12px 20px;margin-bottom:36px;}
  .hero-check{display:flex;align-items:center;gap:7px;font-size:14px;font-weight:600;color:rgba(255,255,255,.88);}
  .hero-check svg{color:#00C49A;flex-shrink:0;}
  .hero-btns{display:flex;gap:12px;flex-wrap:wrap;}
  .form-card{background:white;border-radius:20px;padding:32px 28px;box-shadow:0 20px 60px rgba(11,31,58,.18);border:1px solid rgba(11,31,58,.06);}
  .form-card-head h3{font-family:'Cormorant Garamond',serif;font-size:22px;color:#0B1F3A;margin-bottom:4px;}
  .form-card-head p{font-size:13px;color:#64748b;margin-bottom:22px;line-height:1.5;}
  .form-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;}
  .fg{display:flex;flex-direction:column;gap:4px;}
  .fg.full{grid-column:1/-1;}
  .fg label{font-size:11px;font-weight:700;color:#0B1F3A;letter-spacing:.05em;text-transform:uppercase;}
  .fg input,.fg select{padding:11px 13px;border:1.5px solid #d8e1f0;border-radius:9px;font-size:14px;font-family:'Nunito Sans',sans-serif;color:#0f172a;background:#F7F9FC;outline:none;transition:border-color .18s,box-shadow .18s;}
  .fg input:focus,.fg select:focus{border-color:#1E5EBF;box-shadow:0 0 0 3px rgba(30,94,191,.12);}
  .fg.err input,.fg.err select{border-color:#DC2626;background:#FEF2F2;}
  .field-error{font-size:11px;color:#B91C1C;font-weight:600;margin-top:2px;}
  .form-lead-note{background:#F0F6FF;border:1px solid #C7D9F5;border-radius:9px;padding:10px 14px;font-size:12.5px;color:#0B1F3A;margin:0 0 14px;line-height:1.55;font-weight:600;}
  .form-consent{display:flex;align-items:flex-start;gap:10px;margin:16px 0 4px;padding:12px 14px;background:#F8FAFC;border:1.5px solid #d8e1f0;border-radius:9px;cursor:pointer;transition:border-color .18s,background .18s;}
  .form-consent input[type=checkbox]{margin-top:3px;width:16px;height:16px;flex-shrink:0;accent-color:#1E5EBF;cursor:pointer;}
  .form-consent span{font-size:13px;color:#0f172a;line-height:1.5;}
  .form-consent.err{border-color:#DC2626;background:#FEF2F2;}
  .consent-err{display:block;font-size:11px;color:#B91C1C;font-weight:600;margin:2px 0 4px;}
  .honeypot{display:none!important;visibility:hidden;position:absolute;left:-9999px;}
  .form-submit{width:100%;padding:15px;margin-top:10px;background:linear-gradient(135deg,#1E5EBF,#1648a0);color:white;border:none;border-radius:11px;font-size:16px;font-weight:800;font-family:'Nunito Sans',sans-serif;cursor:pointer;transition:transform .2s,box-shadow .2s,opacity .2s;}
  .form-submit:hover:not(:disabled){transform:translateY(-2px);box-shadow:0 8px 24px rgba(30,94,191,.4);}
  .form-submit:disabled{opacity:.65;cursor:not-allowed;}
  .form-note{font-size:11px;color:#64748b;text-align:center;margin-top:10px;line-height:1.6;}
  .form-success{text-align:center;padding:32px 16px;}
  .form-success h3{font-size:22px;color:#0B1F3A;margin-bottom:8px;font-family:'Cormorant Garamond',serif;}
  .form-success p{font-size:14px;color:#64748b;margin-bottom:16px;}
  .form-err-msg{background:#FEF2F2;border:1px solid #FECACA;border-radius:9px;padding:12px 16px;margin-top:10px;font-size:13px;color:#991B1B;text-align:center;}
  .consent-box{background:#F0F6FF;border:1px solid #C7D9F5;border-radius:10px;padding:16px 18px;margin-top:16px;}
  .consent-box p{font-size:11px;color:#334155;line-height:1.65;}
  .consent-box strong{color:#0B1F3A;font-size:11px;}
  .sec{padding:88px 28px;}
  .sec-cream{background:#F7F9FC;}
  .sec-navy{background:#0B1F3A;}
  .sec-white{background:white;}
  .wrap{max-width:1100px;margin:0 auto;}
  .tag{display:inline-block;font-size:11px;font-weight:700;letter-spacing:.1em;text-transform:uppercase;color:#1E5EBF;margin-bottom:10px;}
  .tag-mint{color:#00C49A;}
  .sec-title{font-size:clamp(28px,4vw,44px);color:#0B1F3A;margin-bottom:14px;font-family:'Cormorant Garamond',serif;}
  .sec-title.white{color:white;}
  .sec-sub{font-size:17px;color:#64748b;line-height:1.7;max-width:540px;}
  .sec-sub.white{color:rgba(255,255,255,.7);}
  .sec-head{margin-bottom:54px;}
  .sec-head.center{text-align:center;}
  .sec-head.center .sec-sub{margin:0 auto;}
  .trust-grid{display:grid;grid-template-columns:repeat(4,1fr);gap:22px;}
  .trust-card{background:white;border-radius:12px;padding:28px 22px;text-align:center;box-shadow:0 2px 10px rgba(11,31,58,.08);border:1px solid rgba(11,31,58,.06);transition:transform .25s,box-shadow .25s;}
  .trust-card:hover{transform:translateY(-5px);box-shadow:0 8px 30px rgba(11,31,58,.13);}
  .trust-icon{width:54px;height:54px;background:rgba(30,94,191,.08);border-radius:14px;display:flex;align-items:center;justify-content:center;margin:0 auto 14px;color:#1E5EBF;}
  .trust-card h4{font-family:'Nunito Sans',sans-serif;font-size:14px;font-weight:800;color:#0B1F3A;margin-bottom:6px;}
  .trust-card p{font-size:13px;color:#64748b;line-height:1.55;}
  .steps{display:grid;grid-template-columns:repeat(3,1fr);gap:32px;}
  .step{text-align:center;padding:16px;}
  .step-num{width:68px;height:68px;background:linear-gradient(135deg,#1E5EBF,#1648a0);border-radius:50%;display:flex;align-items:center;justify-content:center;margin:0 auto 18px;font-family:'Cormorant Garamond',serif;font-size:26px;font-weight:700;color:white;box-shadow:0 6px 20px rgba(30,94,191,.32);}
  .step h4{font-family:'Nunito Sans',sans-serif;font-size:16px;font-weight:800;color:#0B1F3A;margin-bottom:8px;}
  .step p{font-size:14px;color:#64748b;line-height:1.65;}
  .who-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(160px,1fr));gap:16px;}
  .who-card{background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);border-radius:12px;padding:22px 16px;text-align:center;transition:background .2s;}
  .who-card:hover{background:rgba(255,255,255,.1);}
  .who-card .ico{font-size:28px;margin-bottom:8px;}
  .who-card span{color:white;font-size:14px;font-weight:600;}
  .testi-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(250px,1fr));gap:22px;}
  .testi-card{background:white;border-radius:12px;padding:26px;box-shadow:0 2px 10px rgba(11,31,58,.08);border:1px solid rgba(11,31,58,.07);transition:transform .22s;}
  .testi-card:hover{transform:translateY(-4px);}
  .testi-top{display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;}
  .stars{color:#F59E0B;letter-spacing:2px;font-size:14px;}
  .state-badge{background:#F7F9FC;border:1px solid #d8e1f0;border-radius:6px;padding:3px 8px;font-size:11px;font-weight:700;color:#1E5EBF;}
  .testi-card blockquote{font-size:14px;color:#0f172a;line-height:1.7;margin-bottom:18px;font-style:italic;}
  .testi-author{display:flex;align-items:center;gap:10px;}
  .testi-av{width:40px;height:40px;background:linear-gradient(135deg,#1E5EBF,#0B1F3A);border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:800;font-size:15px;color:white;flex-shrink:0;}
  .testi-name{font-size:13px;font-weight:800;color:#0B1F3A;}
  .testi-meta{font-size:12px;color:#64748b;}
  .cta-band{background:linear-gradient(135deg,#1E5EBF,#1648a0);padding:76px 28px;text-align:center;}
  .cta-band h2{color:white;font-size:clamp(26px,4vw,42px);margin-bottom:12px;font-family:'Cormorant Garamond',serif;}
  .cta-band p{color:rgba(255,255,255,.8);font-size:17px;margin-bottom:36px;}
  .cta-btns{display:flex;justify-content:center;gap:14px;flex-wrap:wrap;}
  .feature-row{display:grid;grid-template-columns:1fr 1fr;gap:64px;align-items:center;}
  .feature-img{border-radius:20px;overflow:hidden;box-shadow:0 20px 60px rgba(11,31,58,.18);}
  .feature-img img{width:100%;display:block;}
  .check-list{display:flex;flex-direction:column;gap:14px;margin:22px 0 30px;}
  .check-item{display:flex;align-items:flex-start;gap:12px;}
  .check-dot{width:22px;height:22px;background:rgba(30,94,191,.1);border-radius:50%;display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:1px;color:#1E5EBF;}
  .check-item p{font-size:15px;color:#0f172a;line-height:1.55;}
  .lead-sec{background:#F7F9FC;padding:88px 28px;}
  .lead-inner{max-width:680px;margin:0 auto;}
  .footer{background:#0B1F3A;color:white;padding:60px 28px 28px;}
  .footer-inner{max-width:1100px;margin:0 auto;}
  .footer-top{display:grid;grid-template-columns:2fr 1fr 1fr 1fr;gap:44px;margin-bottom:44px;}
  .footer-logo{display:flex;align-items:center;gap:10px;margin-bottom:14px;}
  .footer-logo img{width:42px;height:42px;border-radius:50%;object-fit:cover;box-shadow:0 0 0 2px rgba(255,255,255,.2);}
  .footer-logo span{font-family:'Cormorant Garamond',serif;font-size:16px;font-weight:700;}
  .footer-brand p{color:rgba(255,255,255,.55);font-size:13px;line-height:1.75;max-width:250px;margin-bottom:10px;}
  .footer-contact a{display:block;color:#00C49A;font-weight:700;font-size:14px;text-decoration:none;margin-bottom:6px;transition:color .18s;}
  .footer-contact a:hover{color:white;}
  .footer-col h5{font-family:'Nunito Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:rgba(255,255,255,.45);margin-bottom:14px;}
  .footer-col a{display:block;color:rgba(255,255,255,.7);font-size:13.5px;text-decoration:none;margin-bottom:9px;transition:color .18s;cursor:pointer;}
  .footer-col a:hover{color:white;}
  .footer-divider{border:none;border-top:1px solid rgba(255,255,255,.1);margin:0 0 24px;}
  .footer-legal{margin-bottom:24px;}
  .footer-legal h5{font-family:'Nunito Sans',sans-serif;font-size:11px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:rgba(255,255,255,.45);margin-bottom:14px;}
  .footer-legal-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:24px;}
  .footer-legal-block h6{font-family:'Nunito Sans',sans-serif;font-size:12px;font-weight:700;color:rgba(255,255,255,.8);margin-bottom:8px;text-transform:uppercase;letter-spacing:.06em;}
  .footer-legal-block p{font-size:11px;color:rgba(255,255,255,.45);line-height:1.65;white-space:pre-line;}
  .footer-bottom{border-top:1px solid rgba(255,255,255,.1);padding-top:22px;display:flex;justify-content:space-between;align-items:center;font-size:12px;color:rgba(255,255,255,.38);flex-wrap:wrap;gap:8px;}
  .footer-disc{font-size:11px;color:rgba(255,255,255,.28);margin-top:12px;line-height:1.65;}
  @media(max-width:960px){
    .hero-inner,.feature-row{grid-template-columns:1fr;}
    .hero-form-col{display:none;}
    .trust-grid{grid-template-columns:repeat(2,1fr);}
    .steps{grid-template-columns:1fr;}
    .footer-top{grid-template-columns:1fr 1fr;gap:28px;}
    .footer-legal-grid{grid-template-columns:1fr;}
    .nav-links{display:none;}
    .hamburger{display:block;}
    .form-grid{grid-template-columns:1fr;}
  }
  @media(max-width:580px){
    .sec{padding:56px 20px;}
    .trust-grid{grid-template-columns:1fr 1fr;}
    .footer-top{grid-template-columns:1fr;}
    .hero{padding:56px 20px 48px;}
    .cta-band{padding:52px 20px;}
  }
`;

// ─── LOGO (small inline SVG placeholder that matches the circular logo style) ─
const LOGO_SRC = 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=100&q=80';

// ─── LEAD FORM ───────────────────────────────────────────────────────────────
interface FormData {
  firstName: string;
  lastName: string;
  phone: string;
  email: string;
  state: string;
  zip: string;
  age: string;
  insured: string;
  coverage: string;
  disability: string;
  coverageStart: string;
  callTime: string;
  consent: boolean;
  _hp: string;
}

const INITIAL_FORM: FormData = {
  firstName: '', lastName: '', phone: '', email: '', state: '', zip: '',
  age: '', insured: '', coverage: '', disability: '', coverageStart: '', callTime: '',
  consent: false, _hp: ''
};

function LeadForm({
  title = 'Get Your Free Quote',
  sub = 'Fill out the form — a licensed agent will reach out within 1 business day.',
  cta = 'Connect With a Licensed Agent'
}: {title?: string;sub?: string;cta?: string;}) {
  const [f, setF] = useState<FormData>(INITIAL_FORM);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

  const set = (k: keyof FormData) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const v = e.target.type === 'checkbox' ? (e.target as HTMLInputElement).checked : e.target.value;
    setF((prev) => ({ ...prev, [k]: v }));
    setErrors((prev) => {const n = { ...prev };delete n[k];return n;});
  };

  const validate = () => {
    const e: Record<string, string> = {};
    const req: (keyof FormData)[] = ['firstName', 'lastName', 'phone', 'email', 'state', 'zip', 'age', 'insured', 'coverage', 'coverageStart', 'callTime'];
    req.forEach((k) => {if (!String(f[k] ?? '').trim()) e[k] = 'Required';});
    if (!f.consent) e.consent = 'Required';
    return e;
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (f._hp) return;
    const v = validate();
    if (Object.keys(v).length) {setErrors(v);return;}
    setErrors({});
    setStatus('loading');
    try {
      const supabase = createClient();
      const { error: dbError } = await supabase.from('inbound_submissions').insert({
        name: `${f.firstName} ${f.lastName}`.trim(),
        email: f.email,
        phone: f.phone,
        message: JSON.stringify({
          state: f.state,
          zip: f.zip,
          age: f.age,
          insured: f.insured,
          coverage: f.coverage,
          disability: f.disability,
          coverageStart: f.coverageStart,
          callTime: f.callTime,
        }),
        form_type: 'contact',
        tcpa_consent: f.consent,
        status: 'pending',
      });
      if (dbError) {
        console.error('Supabase insert error:', dbError.message);
        setStatus('error');
        return;
      }
      setStatus('success');
      setF(INITIAL_FORM);
    } catch {setStatus('error');}
  };

  if (status === 'success') return (
    <div className="form-success">
      <IcoSuccess />
      <h3>Thank you!</h3>
      <p>A licensed agent will contact you shortly.<br />You can also call us at <strong>{PHONE}</strong>.</p>
      <button className="form-submit" onClick={() => setStatus('idle')} style={{ marginTop: 18 }}>Submit Another Request</button>
    </div>);


  const fg = (k: keyof FormData, extra = '') => `fg${extra ? ' ' + extra : ''}${errors[k] ? ' err' : ''}`;
  const err = (k: keyof FormData) => errors[k] ? <span className="field-error">{errors[k]}</span> : null;

  return (
    <form onSubmit={submit} noValidate>
      <input className="honeypot" type="text" value={f._hp} onChange={set('_hp')} tabIndex={-1} autoComplete="off" />
      <div className="form-card-head"><h3>{title}</h3><p>{sub}</p></div>
      <p className="form-lead-note">Please complete all fields so a licensed agent can match you with the right options.</p>
      <div className="form-grid">
        <div className={fg('firstName')}><label>First Name *</label><input placeholder="Jane" value={f.firstName} onChange={set('firstName')} />{err('firstName')}</div>
        <div className={fg('lastName')}><label>Last Name *</label><input placeholder="Smith" value={f.lastName} onChange={set('lastName')} />{err('lastName')}</div>
        <div className={fg('phone')}><label>Phone *</label><input type="tel" placeholder="(941) 555-0100" value={f.phone} onChange={set('phone')} />{err('phone')}</div>
        <div className={fg('email')}><label>Email *</label><input type="email" placeholder="jane@email.com" value={f.email} onChange={set('email')} />{err('email')}</div>
        <div className={fg('state')}><label>State *</label>
          <select value={f.state} onChange={set('state')}>
            <option value="">Select an option</option>
            {US_STATES.map((s) => <option key={s}>{s}</option>)}
          </select>{err('state')}
        </div>
        <div className={fg('zip')}><label>Zip Code *</label><input placeholder="34201" value={f.zip} onChange={set('zip')} />{err('zip')}</div>
        <div className={fg('age')}><label>Age *</label><input type="number" min="18" max="99" placeholder="35" value={f.age} onChange={set('age')} />{err('age')}</div>
        <div className={fg('insured')}><label>Currently Insured? *</label>
          <select value={f.insured} onChange={set('insured')}>
            <option value="">Select an option</option>
            <option>Yes</option><option>No</option>
          </select>{err('insured')}
        </div>
        <div className={fg('coverage')}><label>Coverage Needed *</label>
          <select value={f.coverage} onChange={set('coverage')}>
            <option value="">Select an option</option>
            <option>Health</option><option>Dental</option><option>Vision</option><option>Life Insurance</option><option>Multiple</option>
          </select>{err('coverage')}
        </div>
        <div className={fg('disability')}><label>Currently on Disability?</label>
          <select value={f.disability} onChange={set('disability')}>
            <option value="">Select an option</option>
            <option>Yes</option><option>No</option>
          </select>
        </div>
        <div className={fg('coverageStart')}><label>Coverage Start Date *</label>
          <select value={f.coverageStart} onChange={set('coverageStart')}>
            <option value="">Select an option</option>
            <option>ASAP</option><option>1st of next month</option><option>In 2 months</option><option>3 months +</option>
          </select>{err('coverageStart')}
        </div>
        <div className={fg('callTime', 'full')}><label>Best Time to Call *</label>
          <select value={f.callTime} onChange={set('callTime')}>
            <option value="">Select an option</option>
            <option>Call Me Now</option>
            <option>Morning (8am–12pm)</option>
            <option>Afternoon (12pm–5pm)</option>
            <option>Evening (5pm–8pm)</option>
          </select>{err('callTime')}
        </div>
      </div>
      <label className={`form-consent${errors.consent ? ' err' : ''}`}>
        <input type="checkbox" checked={f.consent} onChange={set('consent')} />
        <span>I confirm I am looking for health coverage options and would like to be contacted.</span>
      </label>
      {errors.consent && <span className="consent-err">{errors.consent}</span>}
      <button className="form-submit" type="submit" disabled={status === 'loading'}>
        {status === 'loading' ? 'Submitting…' : cta}
      </button>
      {status === 'error' && <div className="form-err-msg">Something went wrong. Please try again or call us at {PHONE}.</div>}
      <p className="form-note">🔒 Your info is private and secure.</p>
      <div className="consent-box">
        <p><strong>Consent for Contact:</strong> Your information is secure and never sold to unauthorized parties. By clicking &ldquo;Connect With a Licensed Agent,&rdquo; you agree to be contacted by a licensed insurance agent or partner via phone call, text message, and/or email using automated technology at the number you provided, even if your number is on a Do Not Call list. Consent is not required to purchase services.</p>
      </div>
    </form>);

}

// ─── TRUST BADGES ────────────────────────────────────────────────────────────
function TrustBadges() {
  const items = [
  { icon: <IcoAward />, title: 'Licensed Agents', desc: 'Every consultation is with a state-licensed insurance professional.' },
  { icon: <IcoUsers />, title: 'Multiple Carriers', desc: 'We compare plans across a broad network of trusted insurance providers.' },
  { icon: <IcoStar />, title: 'Personalized Guidance', desc: 'Recommendations tailored to your age, income, state, and family situation.' },
  { icon: <IcoDollar />, title: 'No-Cost Consultation', desc: "Our guidance is 100% free. We're paid by carriers, never by you." }];

  return (
    <div className="sec sec-white">
      <div className="wrap">
        <div className="trust-grid">
          {items.map((b, i) =>
          <div className="trust-card" key={i}>
              <div className="trust-icon">{b.icon}</div>
              <h4>{b.title}</h4>
              <p>{b.desc}</p>
            </div>
          )}
        </div>
      </div>
    </div>);

}

// ─── HOW IT WORKS ────────────────────────────────────────────────────────────
function HowItWorks() {
  const steps = [
  { n: '1', t: 'Quick 5-Minute Call or Text', d: 'Tell us about your situation — no lengthy forms, no pressure. Just an honest conversation.' },
  { n: '2', t: 'Compare Your Options', d: 'We pull together available plans and pricing in your area so you can see what fits.' },
  { n: '3', t: 'Enroll With Confidence', d: "When you're ready, we walk you through every step — and stay with you after." }];

  return (
    <div className="sec sec-cream">
      <div className="wrap">
        <div className="sec-head center">
          <div className="tag">Simple Process</div>
          <h2 className="sec-title">Three steps to better coverage</h2>
          <p className="sec-sub">We&apos;ve helped thousands find coverage that fits — starting with one quick conversation.</p>
        </div>
        <div className="steps">
          {steps.map((s, i) =>
          <div className="step" key={i}>
              <div className="step-num">{s.n}</div>
              <h4>{s.t}</h4>
              <p>{s.d}</p>
            </div>
          )}
        </div>
      </div>
    </div>);

}

// ─── TESTIMONIALS ────────────────────────────────────────────────────────────
function Testimonials() {
  const reviews = [
  { q: 'I left my job and panicked about losing insurance. They walked me through everything in one call and found a plan way more affordable than COBRA.', name: 'Maria T.', meta: 'Atlanta, GA · Left employer coverage', init: 'M', state: 'GA' },
  { q: 'As a freelancer I had no idea where to start. This team explained my options clearly and helped me find a plan that fits my budget and life.', name: 'Derek H.', meta: 'Little Rock, AR · 1099 Contractor', init: 'D', state: 'AR' },
  { q: 'Zero pressure at all. They gave me honest options and let me decide. Saving over $200 a month now compared to COBRA.', name: 'Sandra R.', meta: 'Phoenix, AZ · Self-Employed', init: 'S', state: 'AZ' },
  { q: 'Switching jobs left me scrambling. They found me a solid marketplace plan the same week I called. Incredibly smooth process.', name: 'James W.', meta: 'Louisville, KY · Job Transition', init: 'J', state: 'KY' },
  { q: 'I always assumed good coverage would be way out of my budget. They proved me completely wrong.', name: 'Carla M.', meta: 'Tampa, FL · Self-Employed', init: 'C', state: 'FL' }];

  return (
    <div className="sec sec-white">
      <div className="wrap">
        <div className="sec-head center">
          <div className="tag">Real People. Real Results.</div>
          <h2 className="sec-title">What our clients say</h2>
          <p className="sec-sub">Helping people across the country find coverage that fits their life.</p>
        </div>
        <div className="testi-grid">
          {reviews.map((r, i) =>
          <div className="testi-card" key={i}>
              <div className="testi-top">
                <div className="stars">★★★★★</div>
                <div className="state-badge">{r.state}</div>
              </div>
              <blockquote>&ldquo;{r.q}&rdquo;</blockquote>
              <div className="testi-author">
                <div className="testi-av">{r.init}</div>
                <div>
                  <div className="testi-name">{r.name}</div>
                  <div className="testi-meta">{r.meta}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>);

}

// ─── CTA BAND ────────────────────────────────────────────────────────────────
function CTABand({ headline, sub, onQuote }: {headline: string;sub: string;onQuote: () => void;}) {
  return (
    <div className="cta-band">
      <div className="wrap">
        <h2>{headline}</h2>
        <p>{sub}</p>
        <div className="cta-btns">
          <button className="btn btn-white" onClick={onQuote}>Get My Free Quote <IcoArrow /></button>
        </div>
      </div>
    </div>);

}

// ─── HEADER ──────────────────────────────────────────────────────────────────
function Header({ onQuote }: {onQuote: () => void;}) {
  const [open, setOpen] = useState(false);
  const pages = ['Home', 'Lost Coverage', 'Self-Employed', 'Services', 'About'];

  const scrollTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });else
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <nav className="nav">
        <button className="nav-logo" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <img src={LOGO_SRC} alt="Health Coverage Options Center logo" />
          <div className="nav-logo-text">Health Coverage Options<small>Center</small></div>
        </button>
        <div className="nav-links">
          {pages.map((p) =>
          <button key={p} className={p === 'Home' ? 'active' : ''} onClick={() => scrollTo(p === 'Home' ? 'hero' : p.toLowerCase().replace(' ', '-'))}>{p}</button>
          )}
        </div>
        <button className="hamburger" onClick={() => setOpen((o) => !o)} aria-label="Menu">
          <svg width="24" height="24" fill="none" stroke="#0B1F3A" strokeWidth="2" viewBox="0 0 24 24">
            {open ?
            <><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></> :
            <><line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" /></>}
          </svg>
        </button>
      </nav>
      <div className={`mob-menu${open ? ' open' : ''}`}>
        {pages.map((p) =>
        <button key={p} onClick={() => scrollTo(p === 'Home' ? 'hero' : p.toLowerCase().replace(' ', '-'))}>{p}</button>
        )}
        <button className="mob-phone" onClick={() => {onQuote();setOpen(false);}}>Get My Free Quote</button>
      </div>
    </>);

}

// ─── FOOTER ──────────────────────────────────────────────────────────────────
function Footer({ onQuote }: { onQuote?: () => void }) {
  const privacyContent = `We value your privacy. When you submit your information on this website, we may collect personal details such as your name, phone number, email address, and other relevant information to help connect you with licensed health insurance agents and coverage options.

Your information may be shared with licensed insurance agents for the purpose of providing quotes and coverage options. We do not sell your personal information to unauthorized third parties.

We use industry-standard security measures to protect your information.

By using this website, you consent to the collection and use of your information as described in this policy.

If you have any questions, please contact us at our website.`;

  const termsContent = `By using this website, you agree to the following terms:

This website is a lead generation service designed to connect consumers with licensed insurance agents and providers. We do not directly provide insurance policies.

You agree that the information you provide is accurate and complete.

We are not responsible for the actions, policies, or services of third-party agents or insurance providers.

We reserve the right to modify these terms at any time without prior notice.

Use of this website constitutes your agreement to these terms.`;

  const disclaimerContent = `This website is not affiliated with or endorsed by HealthCare.gov or any government agency.

We are an independent service that connects individuals with licensed insurance agents and providers.`;

  const [year, setYear] = useState(2026);
  useEffect(() => {setYear(new Date().getFullYear());}, []);

  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div>
            <div className="footer-logo">
              <img src={LOGO_SRC} alt="logo" />
              <span>Health Coverage Options Center</span>
            </div>
            <div className="footer-brand">
              <p>Licensed insurance professionals helping individuals, families, and self-employed workers navigate health coverage options.</p>
            </div>
            <div className="footer-contact">
            </div>
          </div>
          <div className="footer-col">
            <h5>Pages</h5>
            {['Home', 'Lost Coverage', 'Self-Employed', 'Services', 'About'].map((p) =>
            <a key={p} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>{p}</a>
            )}
          </div>
          <div className="footer-col">
            <h5>Coverage</h5>
            <a>Health Insurance</a>
            <a>Dental Plans</a>
            <a>Vision Coverage</a>
            <a>Life Insurance</a>
            <a>Marketplace Plans</a>
          </div>
          <div className="footer-col">
            <h5>Contact</h5>
            <a onClick={() => onQuote ? onQuote() : undefined}>Get a Free Quote</a>
          </div>
        </div>
        <hr className="footer-divider" />
        <div className="footer-legal">
          <h5>Legal</h5>
          <div className="footer-legal-grid">
            <div className="footer-legal-block">
              <h6>Privacy Policy</h6>
              <p>{privacyContent}</p>
            </div>
            <div className="footer-legal-block">
              <h6>Terms &amp; Conditions</h6>
              <p>{termsContent}</p>
            </div>
            <div className="footer-legal-block">
              <h6>Disclaimer</h6>
              <p>{disclaimerContent}</p>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {year} Health Coverage Options Center. All rights reserved.</span>
          <span>This site is not affiliated with or endorsed by HealthCare.gov or any government agency.</span>
        </div>
      </div>
    </footer>);

}

// ─── MAIN PAGE ───────────────────────────────────────────────────────────────
export default function HomePage() {
  const formRef = useRef<HTMLDivElement>(null);
  const bottomFormRef = useRef<HTMLDivElement>(null);

  const scrollToForm = useCallback(() => {
    // On mobile the hero form column is hidden (display:none); fall back to the bottom form
    if (formRef.current && formRef.current.offsetParent !== null) {
      formRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (bottomFormRef.current) {
      bottomFormRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, []);

  const scrollToBottomForm = useCallback(() => {
    if (bottomFormRef.current) {
      bottomFormRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }, []);

  return (
    <>
      <style>{css}</style>
      <Header onQuote={scrollToForm} />
      <main>
        {/* HERO */}
        <section className="hero" id="hero">
          <div className="hero-inner">
            <div>
              <div className="hero-badge">
                <div className="hero-badge-dot" />
                <span>Licensed Insurance Agents</span>
              </div>
              <h1>Lost Coverage?<br /><em>Compare Your Options</em><br />in Minutes.</h1>
              <p className="hero-sub">
                Whether you&apos;re self-employed, between jobs, or done with COBRA sticker shock — there may be better options. See what&apos;s available at no cost to you.
              </p>
              <div className="hero-checks">
                {['No cost to you', 'Multiple carriers compared', 'Personalized plan guidance', 'Enroll with confidence'].map((t) =>
                <div className="hero-check" key={t}><IcoCheck /> {t}</div>
                )}
              </div>
              <div className="hero-btns">
                <button className="btn btn-mint" onClick={scrollToForm}>Get My Free Quote <IcoArrow /></button>
              </div>
            </div>
            <div className="hero-form-col" ref={formRef}>
              <div className="form-card">
                <LeadForm />
              </div>
            </div>
          </div>
        </section>

        {/* TRUST BADGES */}
        <TrustBadges />

        {/* HOW IT WORKS */}
        <HowItWorks />

        {/* WHO WE SERVE */}
        <div className="sec sec-navy" id="lost-coverage">
          <div className="wrap">
            <div className="sec-head center">
              <div className="tag tag-mint">Who We Serve</div>
              <h2 className="sec-title white">Coverage solutions for your situation</h2>
              <p className="sec-sub white">Whatever your work situation — we can help you find coverage that fits.</p>
            </div>
            <div className="who-grid">
              {[
              { ico: '💼', label: 'Losing Job Coverage' },
              { ico: '🔄', label: 'COBRA Alternatives' },
              { ico: '💡', label: 'Self-Employed / 1099' },
              { ico: '🏠', label: 'Freelancers & Contractors' },
              { ico: '👨‍👩‍👧', label: 'Families & Individuals' },
              { ico: '📊', label: 'Small Business Owners' }].
              map((w, i) =>
              <div className="who-card" key={i}>
                  <div className="ico">{w.ico}</div>
                  <span>{w.label}</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* TESTIMONIALS */}
        <Testimonials />

        {/* FEATURE ROW */}
        <div className="sec sec-cream" id="services">
          <div className="wrap">
            <div className="feature-row">
              <div>
                <div className="tag">Plan Comparisons Made Simple</div>
                <h2 className="sec-title">See your options side by side</h2>
                <div className="check-list">
                  {[
                  "We compare plans across multiple carriers so you don't have to guess.",
                  'Pricing and coverage details tailored to your age, state, and income.',
                  'No jargon — just clear guidance from a real licensed professional.'].
                  map((t, i) =>
                  <div className="check-item" key={i}>
                      <div className="check-dot"><IcoCheck /></div>
                      <p>{t}</p>
                    </div>
                  )}
                </div>
                <button className="btn btn-primary" onClick={scrollToBottomForm}>Get My Free Quote <IcoArrow /></button>
              </div>
              <div className="feature-img">
                <img
                  src="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&q=80"
                  alt="Person reviewing insurance plan options at a desk" />

              </div>
            </div>
          </div>
        </div>

        {/* CTA BAND */}
        <CTABand
          headline="Let's See What You Qualify For"
          sub="A licensed agent is ready to help — no cost, no obligation."
          onQuote={scrollToBottomForm} />


        {/* BOTTOM FORM */}
        <div className="lead-sec" id="about">
          <div className="lead-inner">
            <div className="sec-head center">
              <div className="tag">Free Consultation</div>
              <h2 className="sec-title">Ready to see what&apos;s available?</h2>
              <p className="sec-sub" style={{ margin: '0 auto 36px' }}>Fill out the form and a licensed agent will reach out within 1 business day.</p>
            </div>
            <div className="form-card" ref={bottomFormRef}>
              <LeadForm />
            </div>
          </div>
        </div>
      </main>
      <Footer onQuote={scrollToBottomForm} />
    </>);

}